export enum EntitySlideType {
  CoverSlide = 'CoverSlide',
  DiagramAndNotesSlide = 'DiagramAndNotesSlide',
  BalanceSheetSlide = 'BalanceSheetSlide',
  BeneficiariesAndDispositionsSlide = 'BeneficiariesAndDispositionsSlide',
  InsurancePolicySlides = 'InsurancePolicySlides',
}

export interface ExportEntityBundleModalFormShape {
  includeCoverSlide: boolean;
  includeDiagramAndNotesSlide: boolean;
  includeBalanceSheetSlide: boolean;
  includeBeneficiariesAndDispositionsSlide: boolean;
  includeNotesOnDiagramSlide: boolean;
  includeInsurancePolicySlides: boolean;
}
